import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import StatusBadge from 'components/atoms/status-badge'
import { SellerMarketProductOrderItemStatusBadge } from 'domains/seller-market-product-order-item/atoms'
import { STATUS } from 'domains/seller-market-product-order-item/constants'
import PropTypes from 'prop-types'
import React from 'react'
import TimeUtil from 'utils/time-util'


const propTypes = {
  rowButtonProps: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled : PropTypes.func,
      colour     : PropTypes.string,
      onClick    : PropTypes.func,
      text       : PropTypes.string
    })
  )
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Columns definition for Seller Market Product Order Item Table
 * @param {array} rowButtonProps - Array props for row button
 */
const sellerMarketProductOrderItemTableColumns = ({
  rowButtonProps
}) => {
  // Custom filter
  // ** SELLER MARKET ORDER ITEM **
  const StatusFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  StatusFilter.propTypes = filterPropTypes


  // Custom cell
  // ** SELLER MARKET PRODUCT **
  const StatusCell = (row) => <SellerMarketProductOrderItemStatusBadge status={ row.cell.value } />

  const CourierCell = (row) => <StatusBadge color='info' label={ row.cell.value } />

  const ImageCell = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } alt={ row.row.original.seller_market_product.name } />

  // const DateCell = (row) => TimeUtil.format(row.cell.value, 'DD MMM YYYY')

  const ResiPengirimanCell = (row) => {
    if (row.row.values.tracking_number) {
      return TimeUtil.format(row.cell.value, 'DD MMM YYYY')
    }
    return null
  }

  const generateActionCell = () => {

    const buttons = rowButtonProps.map((button) => {

      const ActionCell = ({ cell: { row } }) => {

        const disabled = button.isDisabled ? button.isDisabled(row.original) : false

        return (
          <RowButton
            data={ row.original }
            color={ button.colour }
            disabled={ disabled }
            onClick={ button.onClick }
            text={ button.text }
          />
        )
      }

      ActionCell.propTypes = actionCellPropTypes

      return {
        Header : button.header,
        id     : button.id,
        Cell   : ActionCell
      }
    })

    return buttons
  }

  return (
    [
      {
        Header  : 'Seller Market Product Order Item',
        columns : [
          {
            Header         : 'ID',
            id             : 'id',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header         : 'Courier',
            id             : 'courier',
            accessor       : 'courier',
            disableFilters : true,
            Cell           : CourierCell
          },
          {
            Header         : 'Tracking Number',
            id             : 'tracking_number',
            accessor       : 'tracking_number',
            disableFilters : true
          },
          {
            Header         : 'Updated At',
            id             : 'updated_at',
            accessor       : 'updated_at',
            Cell           : ResiPengirimanCell,
            disableFilters : true
          },
          {
            Header   : 'Status',
            id       : 'status',
            accessor : 'status',
            Filter   : StatusFilter,
            Cell     : StatusCell
          }
        ]
      },
      {
        Header  : 'Seller Market Product',
        columns : [
          {
            Header         : 'ID',
            id             : 'seller_market_product_id',
            accessor       : 'seller_market_product.id',
            disableFilters : true
          },
          {
            Header         : 'Image',
            accessor       : 'seller_market_product.thumbnail',
            disableFilters : true,
            Cell           : ImageCell
          },
          {
            Header   : 'SKU',
            id       : 'seller_market_product_sku',
            accessor : 'seller_market_product.sku'
          },
          {
            Header   : 'Name',
            id       : 'seller_market_product_name',
            accessor : 'seller_market_product.name'
          }
        ]
      },
      {
        Header  : 'Seller',
        columns : [
          {
            Header         : 'ID',
            id             : 'seller_id',
            accessor       : 'seller.id',
            disableFilters : true
          },
          {
            Header   : 'Name',
            id       : 'seller_name',
            accessor : 'seller.name'
          },
          {
            Header   : 'Phone Number',
            id       : 'seller_phone_number',
            accessor : 'seller.mobile'
          }
        ]
      },
      {
        Header  : 'Actions',
        columns : [
          // * Generate action cell with buttonProps
          ...generateActionCell()
        ]
      }
    ]
  )
}

sellerMarketProductOrderItemTableColumns.propTypes = propTypes

export default sellerMarketProductOrderItemTableColumns
